import { createEnum } from "./utils";

const MODAL_ID = {
  ADD_USER: "add-user",
  ADD_ROLE: "add-role",
  ADD_PERMISSION: "add-permission",
  ADD_CATEGORY: "add-category",
  ADD_CAMPAIGN: "add-campaign",
  ADD_SUBCATEGORY: "add-sub-category",
  ADD_VENDOR: "add-vendor",
  ADD_VENDOR_INTEGRATION: "add-vendor-integration",
  ADD_API_ENDPOINT: "add-api-endpoint",
  ADD_PRODUCT: "add-product",
  ADD_OFFER: "add-offer",
  CONFIRM_DELETE: "confirm-delete-done",
  VIEW_IMAGE: "view-image",
  VIEW_OFFERS: "view-offers",
  REJECTION_MODAL: "rejection-modal",
  FILTER_MODAL: "filter-modal",
  SHARE_MODAL :"share-modal",
  ORDER_UPDATE_MODAL :"order-update",
  EXPORT_DATA: "EXPORT_DATA",
  ADD_APP_SETTING: "add-app-setting",
};


const PAGINATION = {
  DEFAULT_ROWS_PER_PAGE: 10,
  DEFAULT_PAGE_NUMBER: 1,
};

const VENDOR_TYPES = {
  "cosmetic store": "Cosmetic Store",
  pharmacy: "Pharmacy",
  other: "Other",
};
createEnum(VENDOR_TYPES);


const  CAMPAIGN_TABS = ['dashboard', 'profile', 'category' ]
createEnum(CAMPAIGN_TABS);

const UNIT_TYPES ={
   mg : "mg",
   g : "g", 
   kg : "kg", 
   ml:"ml",
   l:"l", 
  unit:"unit  "
}
createEnum(UNIT_TYPES)

const ROLE_TYPE=[
    {label:"Admin",value:"2"},
   {label:"Vendor",value:"1"},

 
]

const OFFER_TYPES = { product: "Product", cart: "Cart" };
createEnum(OFFER_TYPES);

const DISCOUNT_TYPES = { percentage: "Percentage", flat: "Flat" };
createEnum(DISCOUNT_TYPES);

const VALIDATION_ERROR_MESSAGES = {
  EMAIL_FORMAT: "Invalid email format!",
  PASSWORD_FORMAT: "Invalid password format!",
  ONLY_NUMBERS: "Only numeric values allowed!",
  INVALID_MOBILE: "Invalid mobile number!",
  ZIP_CODE_FORMAT: "Invalid ZIP code!",
  USERNAME_FORMAT:
    "User name can only contain letters, numbers, dots, hyphens and underscores!",
  API_KEY_FORMAT: "API key must be at least 8 characters (letters, numbers, - or _)!",
};
createEnum(VALIDATION_ERROR_MESSAGES);

const VENDOR_STATUS = ["pending", "approved", "rejected"];
createEnum(VENDOR_STATUS);

const OFFER_STATUS = ["pending", "approved", "rejected"];
createEnum(VENDOR_STATUS);

const CURRENCY_SYMBOL = {
  AE: "AED",
};

const PAYMENT_STATUS = ["pending", "paid", "failed", "refunded"];
createEnum(PAYMENT_STATUS);

const ORDER_STATUS = ["pending", "success", "failed", "cancelled"];
createEnum(ORDER_STATUS);

const DELIVERY_STATUS = [
  "placed",
  "shipped",
  "in_transit",
  "out_for_delivery",
  "delivered",
  "cancelled",
];
createEnum(DELIVERY_STATUS);

const RETURN_ALLOWED_STATUSES = [
  "return-initiated",
  "pickup", 
  "returned", 
  "refunded"
];
createEnum(RETURN_ALLOWED_STATUSES);
 

const PASSWORD_INSTRUCTIONS = [
  "contain atleast 1 lowercase character",
  "contain atleast 1 uppercase character",
  "contain atleast 1 special character",
  "be at least 8 characters long",
  "be maximum 20 characters long",
];
createEnum(PASSWORD_INSTRUCTIONS);


const UPLOAD_FILE_INSTRUCTIONS = [
  "The image background should be white",
  "File must be an image (jpg, jpeg, png)",
  "File name should not contain special characters",
];
createEnum(UPLOAD_FILE_INSTRUCTIONS);

const ORDER_UPDATE_REASONS = [
  "Ordered the wrong medicine",
  "No longer needed the medicine",
  "Found a cheaper alternative",
  "Ordered by mistake",
  "Duplicate order",
  "Change in prescription",
  "Delay in delivery",
  "Preferred local pickup instead",
  "Other (please specify)",
];
createEnum(ORDER_UPDATE_REASONS);

export {
  MODAL_ID,
  PAGINATION,
  VENDOR_TYPES,
  OFFER_TYPES,
  DISCOUNT_TYPES,
  VALIDATION_ERROR_MESSAGES,
  VENDOR_STATUS,
  OFFER_STATUS,
  UNIT_TYPES,
  CURRENCY_SYMBOL,
  PAYMENT_STATUS,
  ORDER_STATUS,
  DELIVERY_STATUS,
  PASSWORD_INSTRUCTIONS,
  ROLE_TYPE,
  UPLOAD_FILE_INSTRUCTIONS,
  // CAMPAIGN_TYPES,
  CAMPAIGN_TABS,
  ORDER_UPDATE_REASONS,
  RETURN_ALLOWED_STATUSES,
};
